module.exports = __webpack_public_path__ + "img/gifEmpty.773cb4fd.gif";